import { createEffect } from 'effector';
import { PostVoteT } from 'src/entity/Pretendents';
import { api } from 'src/shared/api/api';

export const postVotesFx = createEffect<PostVoteT, any, Error>(
  async votes => {
    try {
      const { data } = await api.postFirstStageVotes(votes);
      return data;
    } catch (error) {
      throw new Error('Ошибка при отправке голосов');
    }
  }
);
